import { useViewport } from 'components/general/useViewPort';
import React, { useMemo } from "react";
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { ColumnExpander, ColumnNameH2H, ColumnBib, ColumnGender, ColumnSportClass } from "components/common/TableColumns"
import StatsBox from "components/sports/ru7/views/StatsBox"
import { dateFormat } from "helpers/utils"

import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import { capitalizeFirstLetter } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TableColumns = () => {
  return (
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', headerClassName: 'text-end w-10' }),
      ColumnNameH2H({ showCaptainAbbr: true, showSuspendedCode: true, hideNoc: true }),
      ColumnGender({}),
      ColumnSportClass({}),
      ColumnExpander({ type: 'alwaysTrue', idNode: 'athlete' })
    ]
  )
}

const getConfigurationBox = (date) => {

  const formatedDate = date ? dateFormat(date, "", "D MMM H:mm") : "";

  let configuration = {
    header: `Current Tournament Statistics - ${formatedDate}`,
    stats:[
      {
        order: 1,
        code: 'MINS',
        attr: 'value',
        label: 'HeaderMinutesPlayedTotal',
        title: ''
      }, 
      {
        order: 2,
        code: 'MINS',
        attr: 'avg',
        label: 'HeaderMinutesPlayedAvg',
        title: ''
      }, 
      {
        order: 3,
        code: 'TRY',
        attr: 'value',
        label: 'HeaderTriesTotal',
        title: ''
      }, 
      {
        order: 4,
        code: 'TRY',
        attr: 'avg',
        label: 'HeaderTriesAvg',
        title: ''
      }, 
      {
        order: 5,
        code: 'OF',
        attr: 'value',
        label: 'HeaderOffensiveFoulsTotal',
        title: ''
      }, 
      {
        order: 6,
        code: 'OF',
        attr: 'avg',
        label: 'HeaderOffensiveFoulsAvg',
        title: ''
      }, 
      {
        order: 7,
        code: 'DF',
        attr: 'value',
        label: 'HeaderDefensiveFoulsTotal',
        title: ''
      }, 
      {
        order: 8,
        code: 'DF',
        attr: 'avg',
        label: 'HeaderDefensiveFoulsAvg',
        title: ''
      }, 
      {
        order: 9,
        code: 'TO',
        attr: 'value',
        label: 'HeaderTurnoversTotal',
        title: ''
      }, 
      {
        order: 10,
        code: 'TO',
        attr: 'avg',
        label: 'HeaderTurnoversAvg',
        title: ''
      }, 
      {
        order: 11,
        code: 'ST',
        attr: 'value',
        label: 'HeaderStealsTotal',
        title: ''
      }, 
      {
        order: 12,
        code: 'ST',
        attr: 'avg',
        label: 'HeaderStealsAvg',
        title: ''
      }, 
      {
        order: 13,
        code: 'FF',
        attr: 'value',
        label: 'HeaderFlagrantFoulsTotal',
        title: ''
      }, 
      {
        order: 14,
        code: 'FF',
        attr: 'avg',
        label: 'HeaderFlagrantFoulsAvg',
        title: ''
      }, 
      {
        order: 15,
        code: 'DQF',
        attr: 'value',
        label: 'HeaderDisqualifyingFoulsTotal',
        title: ''
      }, 
      {
        order: 16,
        code: 'DQF',
        attr: 'avg',
        label: 'HeaderDisqualifyingFoulsAvg',
        title: ''
      }, 
      {
        order: 17,
        code: 'PTY',
        attr: 'value',
        label: 'HeaderPenaltiesTotal',
        title: ''
      }, 
      {
        order: 18,
        code: 'PTY',
        attr: 'avg',
        label: 'HeaderPenaltiesAvg',
        title: ''
      }
    ]
  }
  return configuration;
}

const getConfiguration = (data, breakPoint, mirs_discipline) => {
  let configuration = {
    columns: [],
    subComponent: null,
    caption: null,
    hiddenColumns: [],
    sortBy: [],
    configs: {
    }
  };

  configuration.captionStarters = (
    <div className="d-flex justify-content-between">
      <div className='d-flex align-items-center'>
        <div className='d-none d-md-block me-1'>
          <Noc className='me-1' {...data?.participant?.organisation} />
        </div>
        <strong>
          <Competitor hidePicture={true} {...data?.participant} />
        </strong>
      </div>
      <div>
        <Jersey data={data} />
      </div>
    </div>
  )
  configuration.columns = TableColumns();

  configuration.captionSubstitutes = (
    <div className='text-start'>
      <Label data="HeaderReplacements" sport={mirs_discipline} />
    </div>
  )

  return configuration;
}

const Jersey = ({ data }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  const uniform = capitalizeFirstLetter(data?.eventUnitEntries?.find(i => i?.eue_code === 'UNIFORM')?.eue_value?.toLowerCase());
  return (
    <>
        {uniform}
    </>
  )
}

const StartListSide = ({ data, resultStatus, config, date }) => {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();

  const configEvent = useMemo(() => getConfiguration(data, breakPoint, mirs_discipline));

  const configBox = useMemo(() => getConfigurationBox(date));

  const renderRowSubComponent = React.useCallback(({ row }) => (
    <LoaderSubComponent component={
      <StatsBox data={row?.original} config={configBox} breakPoint={breakPoint} />
    }
    />
  ), [resultStatus]);

  const starters = data?.teamAthletes?.filter(i => i?.eventUnitEntries?.find(eui => eui?.eue_code === 'STARTER' && eui?.eue_value === 'Y'))
  const substitutes = data?.teamAthletes?.filter(i => !i?.eventUnitEntries?.find(eui => eui?.eue_code === 'STARTER' && eui?.eue_value === 'Y'))

  return (<>
    {data.teamAthletes && (
      <div className="start-list-side-main">
        <div className="row">
          <div className="col-12">
            <MirsTable
              className={"table-start-list"}
              id={`mirs-table-start-list-starters-${mirs_rsc}-${data?.participant?.code}`}
              data={starters}
              columns={configEvent.columns}
              renderRowSubComponent={renderRowSubComponent}
              keyRow='athlete-code'
              caption={configEvent.captionStarters}
              initialSortBy={configEvent.sortBy}
            />
          </div>
          <div className="col-12">
            <MirsTable
              className={"table-start-list"}
              id={`mirs-table-start-list-substitutes-${mirs_rsc}-${data?.participant?.code}`}
              data={substitutes}
              columns={configEvent.columns}
              renderRowSubComponent={renderRowSubComponent}
              keyRow='athlete-code'
              caption={configEvent.captionSubstitutes}
              initialSortBy={configEvent.sortBy}
            />
          </div>
        </div>
      </div>
    )
    }
  </>)
}

export default StartListSide;
